import { render, staticRenderFns } from "./BendProtection.vue?vue&type=template&id=54c6cca4"
import script from "./BendProtection.vue?vue&type=script&lang=js"
export * from "./BendProtection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports